import React, {} from "react";
import Grid from "@material-ui/core/Grid";
import NoRecordFoundImg from "../../../../Assets/Images/no-record.svg";

export const NoRecordFound = () => (

  <div style={{ height: 600 }}>
    <Grid container style={{ height: "100%" }}>
      <Grid item xs={12} md={6} sm={12} >
          <div style={{ position: "relative", height: "100%" }}>
            <div style={{
 position: "absolute", top: "50%", bottom: 0, margin: "auto", width: "100%", textAlign: "center",
}}>
              <span className="t-24">No record found</span>
            </div>
          </div>
      </Grid>
      <Grid item xs={12} md={6} sm={12} >
        <div className="right" style={{ position: "relative", height: "100%" }}>
            <img src={NoRecordFoundImg} className="width80" style={{
 position: "absolute", top: 0, bottom: 0, margin: "auto",
}} />
        </div>
      </Grid>
    </Grid>
  </div>

);
